<template>
  <span
    class="debug-bar-toggle"
  >
    |
    <a
      @click="toggleDevTools"
    >
      DevTools
    </a>

    <span
      class="shortcut-hint"
    >
      ⌘⇧I
    </span>
  </span>
</template>

<script>
export default {
  name: 'DevDebugBarToggle',

  mounted () {
    window.addEventListener('keydown', this.onKeydown)
  },

  beforeUnmount () {
    window.removeEventListener('keydown', this.onKeydown)
  },

  methods: {
    onKeydown (event) {
      // ⌘ + ⇧ + I toggles the planfred debug bar
      if (event.metaKey && event.shiftKey && event.code === 'KeyI') {
        event.preventDefault()
        this.toggleDevTools()
      }
    },

    toggleDevTools () {
      document.body.classList.toggle('show-dev-tools')
    },
  },
}
</script>

<style lang="scss">
.debug-bar-toggle {
  .shortcut-hint {
    margin-left: 5px;
    padding: 4px 5px;
    border: 1px solid #999;
    border-radius: 3px;
    font-size: 0.75em;
    color: #666;
  }
}
</style>
